import { z } from 'zod'
import { REQUIRED_FIELD_MESSAGE } from './login.schema'

export const RegisterSchema = z
  .object({
    user: z
      .object({
        password: z.string().min(1, REQUIRED_FIELD_MESSAGE),
        firstName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
        lastName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
        email: z
          .string()
          .email('El email ingresado no es válido')
          .min(1, REQUIRED_FIELD_MESSAGE),
        username: z.string().min(1, REQUIRED_FIELD_MESSAGE),
      })
      .optional(),
    company: z.object({
      name: z.string().min(1, REQUIRED_FIELD_MESSAGE),
      ein: z
        .string()
        .min(11, 'Mínimo 11 caracteres')
        .regex(new RegExp(/^\d+$/), 'Únicamente dígitos'),
    }),
    identity: z
      .object({
        provider: z.string(),
        access_token: z.string(),
      })
      .optional(),
  })
  .refine(
    (val) => {
      if (!val.identity && !val.user) {
        return false
      }

      return true
    },
    {
      message: 'Este campo es requerido',
    },
  )

export interface IRegisterSchema extends z.infer<typeof RegisterSchema> {}
